import React, { useContext, useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { Spinner } from "reactstrap";
import * as Yup from "yup";
import {
  Box,
  Button,
  Typography,
  MenuItem,
  useMediaQuery,
} from "@mui/material";
import { Chip, IconButton, LinearProgress } from "@mui/material";
import { toast } from "react-toastify";
import ImageIcon from "@mui/icons-material/Image";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CloseIcon from "@mui/icons-material/Close";
import Autocomplete from "@mui/material/Autocomplete";
import { AutocompleteChangeReason } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import {
  GenresArray,
  MoodsArray,
  emailRegex,
  MAX_CHARACTER,
} from "../constants";
import { EmailInviteTextField } from "../../pages/MyTracks/styles";
import { autoCompleteErrorStyle } from "../../pages/MyTracks/styles";
import { autoCompleteStlye, ContainerModal } from "../../pages/MyTracks/styles";
import { styles, useStyles } from "../../pages/MyTracks/styles";
import { UsernameSelectField } from "../../pages/MyTracks/styles";
import { TrackAddModalProps } from "../../pages/MyTracks/types";
// import { TrackObj, VersionAction } from "../../pages/MyTracks/types";
import Audio from "../Audio/Audio";
import { awaitableUploadToS3 } from "../../utils/S3Utils";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { LightTooltip } from "../LightToolTip/LightToolTip";
import {
  Key,
  SongMetadata,
  SplitSheetDetails,
  Track,
  User,
  VersionState,
  VersionStateMap,
} from "../../proto/api_pb";
import { InvitedCollaboratorState, FileState } from "../../proto/api_pb";
import { InviteTemplate, InvitedCollaborator } from "../../proto/api_pb";
import { Collaborator, TrackState, TrackType } from "../../proto/api_pb";
import { TrackVersion, KeyNote, KeyScale } from "../../proto/api_pb";
import { AudioMetadata } from "../../proto/api_pb";
import { postTrackVersion } from "../../services/trackService";
import { postTrack, sendInvites } from "../../services/trackService";
import { RpcError } from "grpc-web";
import { AuthContext, AuthContextInterface } from "../../contexts";
import { S3CredentialsContext, UserDetailsContext } from "../../contexts";
import { UserDetailsContextInterface } from "../../contexts";
import { S3CredentialsContextInterface } from "../../contexts";
import KeyComponent from "../TrackComponents/keyComponent/KeyComponent";
import { useNavigate } from "react-router-dom";
import { CustomLinearProgress } from "../ProgressComponents/CustomLinearProgress";
import { determineSetBpm } from "../../utils/bpmUtil";
import useGetValidAccessToken from "../../hooks/useGetValidAccessToken";
import { isBillingRequired } from "../../utils/subscriptionBillingUtils";
import Mixpanel from "../../utils/mixpanel";
import {
  TrackAddModalColumnContainer,
  TrackEditModalColumnContainer,
  TrackEditModalFormContainer,
} from "./styles";
import { TrackAddModalFormContainer } from "./styles";
import { BORDER_COLOR, FONT_FAMILY } from "../../theme";
import { TrackAddModalMainContainer, trackAddModalStyles } from "./styles";
import { TEXT_COLOR, isEnterprise } from "../../theme";
import { APP_BACKGROUND_COLOR } from "../../theme";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { versionStates } from "./types";
import { getAudioDuration } from "../../pages/MyTracks/utils";

const ASSETS_URL = process.env.REACT_APP_ASSET_S3_BUCKET_URL!;

const TRACK_VALIDATION_SCHEMA = Yup.object().shape({
  artist: Yup.string().max(120, "Too Long!").required("the artist is Required"),
  title: Yup.string()
    .max(120, "Too Long!")
    .required("the song title is Required"),
  bpm: Yup.number()
    .min(0, "Amount must be greater than 0")
    .max(200, "Amount must be less than 200"),
  songUpload: Yup.mixed().required("required"),
  genres: Yup.string().required("Genre is required"),
});

const TRACK_EDIT_VALIDATION_SCHEMA = Yup.object().shape({
  artist: Yup.string().max(120, "Too Long!").required("the artist is Required"),
  title: Yup.string()
    .max(120, "Too Long!")
    .required("the song title is Required"),
  genres: Yup.array()
    .of(Yup.string().max(50, "Genre too long"))
    .min(1, "At least one genre is required")
    .required("Genre is required"),
});

const TrackAddModal: React.FC<TrackAddModalProps> = ({
  trackToEdit,
  trackToEditUrl,
  handleRefreshTracks,
  handleCloseTrackAddModal,
  isModalOpen,
}) => {
  const classes = useStyles();
  const { getValidAccessToken } = useGetValidAccessToken();
  const [collaborators, setCollaborators] = useState<Array<Collaborator>>([]);
  const [genres, setGenres] = useState<Array<string>>([]);
  const [moods, setMoods] = useState<Array<string>>([]);
  const [collabVal, setCollabVal] = useState("");
  const [usersList, setUsersList] = useState<Array<User>>([]);
  const [previewUrl, setPreviewUrl] = useState("");
  const [key, setKey] = useState("");
  const [scale, setScale] = useState("");
  const [showBpmTooltip, setShowBpmTooltip] = useState(false);
  const [showKeyTooltip, setShowKeyTooltip] = useState(false);
  const [showCollabTooltip, setShowCollabTooltip] = useState(false);
  const [trackUrl, setTrackUrl] = useState("");
  const { userId } = useContext<AuthContextInterface>(AuthContext);
  const { userName, storageUsage, subscriptionTier, allUsers } =
    useContext<UserDetailsContextInterface>(UserDetailsContext);
  const { awsAccessKeyId, awsSecretAccessKey, awsSessionToken } =
    useContext<S3CredentialsContextInterface>(S3CredentialsContext);
  const [songChanged, setSongChanged] = useState(false);
  const [progress, setProgress] = useState(0);
  const [currentUpload, setCurrentUpload] = useState("");
  const [bpmLoading, setBpmLoading] = useState(false);
  const navigate = useNavigate();
  const [emailInvite, setEmailInvite] = useState("");
  const [emailInviteList, setEmailInviteList] = useState<string[]>([]);
  const [addedCollabIds, setAddedCollabIds] = useState<string[]>([]);
  const { isEnterpriseAccount, enterprise } = useContext(UserDetailsContext);
  const [versionState, setVersionState] = useState<
    VersionStateMap[keyof VersionStateMap]
  >(VersionState.VERSION_STATE_UNSPECIFIED);
  const [charCount, setCharCount] = useState(0);
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const newTrack = {
    artist: trackToEdit ? trackToEdit.getArtist() : "",
    title: trackToEdit ? trackToEdit.getTitle() : "",
    description: trackToEdit ? trackToEdit.getDescription() : "",
    bpm:
      trackToEdit && trackToEdit.getBpm() !== 0
        ? String(trackToEdit.getBpm())
        : "",
    songUpload: undefined,
    coverArtUpload: undefined,
    genres: trackToEdit ? trackToEdit.getSongMetadata()?.getGenreList() : [],
    album: trackToEdit ? trackToEdit.getSongMetadata()?.getAlbum() : "",
    key: [],
    versionLabel: "",
  };

  useEffect(() => {
    const isNavigating = isBillingRequired(subscriptionTier, storageUsage);
    if (isNavigating && !isEnterpriseAccount) navigate("/billing");

    if (trackToEdit) {
      const editCall = async () => {
        // initializing collabs
        if (trackToEdit?.getCollaboratorsList())
          setCollaborators([...trackToEdit.getCollaboratorsList()]);

        // initializing key
        const keyDataScale = trackToEdit.getKey()?.getScale();
        if (keyDataScale === KeyScale.KEY_SCALE_MAJOR) setScale("major");
        if (keyDataScale === KeyScale.KEY_SCALE_MINOR) setScale("minor");
        const keyData = trackToEdit.getKey()?.getKey();
        const keyDataNote = trackToEdit.getKey()?.getNote();

        if (keyDataNote === KeyNote.KEY_NOTE_FLAT) setKey(`${keyData}b`);
        if (keyDataNote === KeyNote.KEY_NOTE_SHARP) setKey(`${keyData}#`);
        if (keyDataNote === KeyNote.KEY_NOTE_UNDEFINED) setKey(keyData!);

        // initializing genres
        const songData = trackToEdit.getSongMetadata()?.getGenreList();
        const moodData = trackToEdit.getMoodsList();
        setGenres(songData ?? []);
        setMoods(moodData ? moodData : [""]);
        setPreviewUrl(trackToEdit.getImageUrl());
        setTrackUrl(trackToEditUrl ?? "");
      };
      editCall();
    }
  }, [
    trackToEdit,
    userId,
    getValidAccessToken,
    trackToEditUrl,
    navigate,
    storageUsage,
    subscriptionTier,
    isEnterpriseAccount,
  ]);

  const handleshowBpmTooltip = () => {
    setShowBpmTooltip((prev) => !prev);
  };

  const handleshowKeyTooltip = () => {
    setShowKeyTooltip((prev) => !prev);
  };

  const handleShowCollabTooltip = () => {
    setShowCollabTooltip((prev) => !prev);
  };

  const handleSongChanged = () => {
    setSongChanged(true);
  };

  const handleKey = (
    event: React.MouseEvent<HTMLElement>,
    newKey: string | null
  ) => {
    if (newKey !== null) {
      setKey(newKey);
    } else {
      setKey("");
    }
  };

  const handleScale = (
    event: React.MouseEvent<HTMLElement>,
    newScale: string
  ) => {
    if (newScale !== null) {
      setScale(newScale);
    } else {
      setScale("");
    }
  };

  const handleFile = (file: any) => {
    setPreviewUrl(URL.createObjectURL(file));
    URL.revokeObjectURL(previewUrl);
  };
  const handleDragOver = (event: any) => {
    event.preventDefault();
  };

  let clearAudio: any = null;

  useEffect(() => {
    let userL = allUsers.filter((user) => user.getUsername() !== userName);
    if (trackToEdit) {
      const fetchedCollabs = trackToEdit
        .getCollaboratorsList()
        .map((item) => item.getUsername());
      userL = userL.filter(
        (usr) => !fetchedCollabs.includes(usr.getUsername())
      );
      setCollaborators(trackToEdit.getCollaboratorsList());
    }
    setUsersList(userL);
  }, [allUsers, userName, trackToEdit]);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const resetFiles = () => {
    setPreviewUrl("");
    clearAudio();
  };

  const saveResetAudioAction = (clearAction: any) => {
    clearAudio = clearAction;
  };

  const handleProgress = (pNum: number, idx: number) => {
    // file + image
    setProgress(pNum / 2 + idx * (100 / 2));
  };

  const onSubmit = async (
    values: any,
    {
      resetForm,
      setSubmitting,
    }: {
      resetForm: any;
      setSubmitting: any;
    }
  ) => {
    try {
      setSubmitting(true);
      let coverArtUrl = previewUrl;
      // let myTrackObj: TrackObj;
      if (values.coverArtUpload !== undefined) {
        const sanitizedCoverArtFile = new File(
          [values.coverArtUpload],
          encodeURIComponent(values.coverArtUpload.name),
          {
            type: values.coverArtUpload.type,
            lastModified: values.coverArtUpload.lastModified,
          }
        );

        setCurrentUpload("Image");
        const coverArtKey = await awaitableUploadToS3(
          userId,
          sanitizedCoverArtFile,
          `cover-art`,
          sanitizedCoverArtFile.type,
          awsAccessKeyId,
          awsSecretAccessKey,
          awsSessionToken,
          (progress) => handleProgress(progress, 0)
        );
        coverArtUrl = ASSETS_URL + "/" + coverArtKey;
      }

      let songUrl = trackUrl;
      if (songChanged === true) {
        setCurrentUpload("Track");
        const songKey = await awaitableUploadToS3(
          userId,
          values.songUpload,
          `song`,
          values.songUpload!.type,
          awsAccessKeyId,
          awsSecretAccessKey,
          awsSessionToken,
          (progress) => handleProgress(progress, 1)
        );
        songUrl = ASSETS_URL + "/" + songKey;
      }

      const songMetadata = new SongMetadata();
      songMetadata.setGenreList(genres);
      trackToEdit?.setMoodsList(moods);
      songMetadata.setAlbum(values.album);

      const invitedCollabList: InvitedCollaborator[] = [];
      // handling inviting collabs
      if (emailInviteList.length !== 0) {
        emailInviteList.forEach((email) => {
          const newInvitedCollab = new InvitedCollaborator();
          newInvitedCollab.setEmail(email);
          newInvitedCollab.setInvitedCollaboratorState(
            InvitedCollaboratorState.INVITED_COLLABORATOR_STATE_PENDING
          );
          invitedCollabList.push(newInvitedCollab);
        });
      }

      const newkey = new Key();
      if (key.length !== 0) {
        if (key.length === 1) newkey.setKey(key[0]);
        if (key[1] === "b") newkey.setNote(KeyNote.KEY_NOTE_FLAT);
        if (key[1] === "#") newkey.setNote(KeyNote.KEY_NOTE_SHARP);
        newkey.setKey(key[0]);
      }
      if (scale === "major") newkey.setScale(KeyScale.KEY_SCALE_MAJOR);
      if (scale === "minor") newkey.setScale(KeyScale.KEY_SCALE_MINOR);
      // CALL TO API FOR POSTING TRACK
      if (!trackToEdit) {
        // when a new track is added
        let track = new Track();
        track.setOwnerId(userId);
        track.setArtist(values.artist);
        track.setBpm(values.bpm);
        track.setDescription("");
        track.setImageUrl(coverArtUrl);
        track.setTitle(values.title);
        track.setTrackType(TrackType.TRACK_TYPE_SONG);
        track.setState(TrackState.TRACK_STATE_DRAFT);
        track.setSongMetadata(songMetadata);
        track.setCollaboratorsList(collaborators);
        track.setInvitedCollaboratorsList([...invitedCollabList]);
        track.setKey(newkey);
        const sp = new SplitSheetDetails();
        track.setSplitSheetDetails(sp);
        let postTrackResponse = await postTrack(
          track,
          await getValidAccessToken(),
          userId
        );
        if (postTrackResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackResponse;
        }
        track = postTrackResponse.getTrack()!;
        console.log(`Track with id ${track.getId()} added to DB`);

        const trackVersion = new TrackVersion();
        const audioMetadata = new AudioMetadata();
        audioMetadata.setBpm(values.bpm);

        audioMetadata.setKey(newkey);
        console.log("newkey", newkey);
        trackVersion.setLabel(
          values.description === "" ? "Initial upload" : values.description
        );

        trackVersion.setTrackUrl(songUrl);
        trackVersion.setTrackId(track.getId());
        trackVersion.setAudioMetadata(audioMetadata);
        trackVersion.setFileState(FileState.FILE_STATE_ACTIVE);
        trackVersion.setVersionNumber(1);
        trackVersion.setVersionState(versionState);
        trackVersion.setIsPrimary(true);
        const songLength = await getAudioDuration(values.songUpload);
        trackVersion.setLengthSeconds(songLength);
        const postTrackVersionResponse = await postTrackVersion(
          trackVersion,
          await getValidAccessToken(),
          userId,
          isEnterpriseAccount ? enterprise?.id : undefined
        );
        if (postTrackVersionResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackVersionResponse;
        }
        console.log(
          `TrackVersion with id ${postTrackVersionResponse
            .getTrackVersion()!
            .getId()} added to DB for track with id ${track.getId()}`
        );
        track.setTrackVersionId(
          postTrackVersionResponse.getTrackVersion()!.getId()
        );
        postTrackResponse = await postTrack(
          track,
          await getValidAccessToken(),
          userId
        );
        if (postTrackResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackResponse;
        }
        console.log(
          `TrackVersion with id ${postTrackVersionResponse
            .getTrackVersion()!
            .getId()} set as primary version for track with id ${track.getId()}`
        );
        if (emailInviteList.length !== 0 || addedCollabIds.length !== 0) {
          try {
            await sendInvites(
              await getValidAccessToken(),
              emailInviteList,
              addedCollabIds,
              userId,
              `${window.location.origin}/track/${postTrackResponse
                ?.getTrack()
                ?.getId()}`,
              values.title,
              InviteTemplate.INVITE_TEMPLATE_COLLABORATE_TRACK
            );
          } catch (error) {
            console.log(error);
          }
        }
        Mixpanel.track("track_add_success", {
          genre: track.getSongMetadata()?.getGenreList(),
          collab_count: track.getCollaboratorsList().length,
        });
        // set a flag to let the parent know that a new track has been added versionCount: 1
        // myTrackObj = {
        //   track: postTrackResponse.getTrack(),
        //   trackUrl: songUrl,
        //   isPlaying: false,
        //   versionCount: VersionAction.TrackAdded,
        //   latestVersion: postTrackVersionResponse.getTrackVersion(),
        // };
      } else if (trackToEdit && songChanged === false) {
        // when a track is edited and song is not changed
        const track = trackToEdit;
        track.setOwnerId(trackToEdit.getOwnerId());
        track.setArtist(values.artist);
        track.setBpm(values.bpm);
        track.setDescription(values.description);
        track.setImageUrl(coverArtUrl);
        track.setTitle(values.title);
        track.setTrackType(TrackType.TRACK_TYPE_SONG);
        track.setState(TrackState.TRACK_STATE_DRAFT);
        track.setSongMetadata(songMetadata);
        track.setCollaboratorsList(collaborators);
        track.setInvitedCollaboratorsList([
          ...track.getInvitedCollaboratorsList(),
          ...invitedCollabList,
        ]);
        track.setTrackVersionId(trackToEdit.getTrackVersionId());
        track.setKey(newkey);
        const sp = new SplitSheetDetails();
        track.setSplitSheetDetails(sp);
        const postTrackResponse = await postTrack(
          track,
          await getValidAccessToken(),
          userId
        );
        if (postTrackResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackResponse;
        }
        if (emailInviteList.length !== 0 || addedCollabIds.length !== 0) {
          try {
            await sendInvites(
              await getValidAccessToken(),
              emailInviteList,
              addedCollabIds,
              userId,
              `${window.location.origin}/track/${postTrackResponse
                ?.getTrack()
                ?.getId()}`,
              values.title,
              InviteTemplate.INVITE_TEMPLATE_COLLABORATE_TRACK
            );
          } catch (error) {
            console.log(error);
          }
        }
        // set a flag to let the parent know that the track detail has been modified versionCount: -1
        // myTrackObj = {
        //   track: postTrackResponse.getTrack(),
        //   trackUrl: "",
        //   isPlaying: false,
        //   versionCount: VersionAction.TrackEdited,
        //   latestVersion: undefined,
        // };
      } else {
        // when a track is edited and song is changed (needs a new version)
        const track = trackToEdit;
        track.setOwnerId(trackToEdit.getOwnerId());
        track.setArtist(values.artist);
        track.setBpm(values.bpm);
        track.setDescription(values.description);
        track.setImageUrl(coverArtUrl);
        track.setTitle(values.title);
        track.setTrackType(TrackType.TRACK_TYPE_SONG);
        track.setState(TrackState.TRACK_STATE_DRAFT);
        track.setSongMetadata(songMetadata);
        track.setCollaboratorsList(collaborators);
        track.setInvitedCollaboratorsList([
          ...track.getInvitedCollaboratorsList(),
          ...invitedCollabList,
        ]);
        track.setKey(newkey);

        const trackVersion = new TrackVersion();
        const audioMetadata = new AudioMetadata();
        audioMetadata.setBpm(values.bpm);
        trackVersion.setLabel(values.description);
        trackVersion.setAudioMetadata(audioMetadata);
        trackVersion.setTrackUrl(songUrl);
        trackVersion.setTrackId(track.getId());
        trackVersion.setFileState(FileState.FILE_STATE_ACTIVE);
        trackVersion.setVersionNumber(1);
        trackVersion.setVersionState(versionState);
        const postTrackVersionResponse = await postTrackVersion(
          trackVersion,
          await getValidAccessToken(),
          userId,
          isEnterpriseAccount ? enterprise?.id : undefined
        );
        if (postTrackVersionResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackVersionResponse;
        }
        track.setTrackVersionId(
          postTrackVersionResponse.getTrackVersion()!.getId()
        );
        const postTrackResponse = await postTrack(
          track,
          await getValidAccessToken(),
          userId
        );
        if (postTrackResponse instanceof RpcError) {
          //TODO: handle api exception gracefully with error modal, etc
          throw postTrackResponse;
        }
        if (emailInviteList.length !== 0 || addedCollabIds.length !== 0) {
          try {
            await sendInvites(
              await getValidAccessToken(),
              emailInviteList,
              addedCollabIds,
              userId,
              `${window.location.origin}/track/${postTrackResponse
                ?.getTrack()
                ?.getId()}`,
              values.title,
              InviteTemplate.INVITE_TEMPLATE_COLLABORATE_TRACK
            );
          } catch (error) {
            console.log(error);
          }
        }
        Mixpanel.track("track_edit_success", {
          genre: track.getSongMetadata()?.getGenreList(),
          collab_count: track.getCollaboratorsList().length,
        });
        // set a flag to let the parent know that the track song has been modified versionCount: 0
        // myTrackObj = {
        //   track: postTrackResponse.getTrack(),
        //   trackUrl: songUrl,
        //   isPlaying: false,
        //   versionCount: VersionAction.VersionAdded,
        //   latestVersion: postTrackVersionResponse.getTrackVersion(),
        // };
      }

      // once api calls are done
      setSubmitting(false);
      setSongChanged(false);
      resetForm();
      // resetFiles();
      //clearing genres input field
      setGenres([]);
      setScale("");
      setKey("");
      setCollaborators([]);
      setEmailInviteList([]);
      if (handleRefreshTracks) handleRefreshTracks();
      // trackToEdit
      //   ? handleClose(true, "Track successfully updated!", myTrackObj)
      //   : handleClose(true, "Track successfully added!", myTrackObj);
      handleCloseTrackAddModal && handleCloseTrackAddModal();
    } catch (error) {
      console.log(error);
      alert(error);
      setSongChanged(false);
      setSubmitting(false);
    }
  };

  const addCollaborator = (newCollaborator: string) => {
    if (newCollaborator) {
      if (
        collaborators.find(
          (collaborator) => collaborator.getUsername() === newCollaborator
        ) === undefined &&
        usersList.some((user) => user.getUsername() === newCollaborator)
      ) {
        const addedCollab = usersList.find(
          (user) => user.getUsername() === newCollaborator
        );

        if (addedCollab) {
          const newCollab = new Collaborator();
          newCollab.setUserId(addedCollab?.getUserId());
          newCollab.setUsername(addedCollab?.getUsername());
          const updatedCollaborators = [...collaborators, newCollab];

          setAddedCollabIds([...addedCollabIds, addedCollab.getUserId()]);
          setCollaborators(updatedCollaborators);
        }

        const newUserList = usersList.filter(
          (user) => user.getUsername() !== newCollaborator
        );
        setUsersList([...newUserList]);
        setCollabVal("");
      } else {
        toast.info("Username does not exist");
      }
    }
  };

  const removeCollaborator = (collaborator: Collaborator) => {
    const updatedCollaborators = collaborators.filter(
      (item) => item !== collaborator
    );
    setCollaborators(updatedCollaborators);

    // updating userIds list that is being passed in sendInvite
    const updatedUserIdList = addedCollabIds.filter(
      (item) => item !== collaborator.getUserId()
    );
    setAddedCollabIds([...updatedUserIdList]);

    const newUser = new User();
    newUser.setUsername(collaborator.getUsername());
    newUser.setUserId(collaborator.getUserId());

    const newUsersList = [...usersList, newUser];
    setUsersList([...newUsersList]);
  };

  const handleCollabInvites = (event: React.SyntheticEvent<Element, Event>) => {
    if (emailInvite) {
      if (emailInvite.match(emailRegex)) {
        setEmailInviteList([...emailInviteList, emailInvite]);
        setEmailInvite("");
      } else {
        toast.info("Invalid email address!");
      }
    }
  };

  const handleRemoveEmail = (email: string) => {
    const updateEmailList = emailInviteList.filter((item) => item !== email);
    setEmailInviteList(updateEmailList);
  };

  const handleStatusChange = (event: any) => {
    setVersionState(
      event.target.value as VersionStateMap[keyof VersionStateMap]
    );
  };

  return (
    <ContainerModal
      open={isModalOpen ? isModalOpen : false}
      onClose={handleCloseTrackAddModal}
      style={{ overflow: "auto" }}
    >
      <>
        {!trackToEdit && (
          <TrackAddModalFormContainer className="form-container">
            <Box>
              <Box style={styles.modalHeaderContainer}>
                <span style={styles.modalHeader}>
                  <Box sx={trackAddModalStyles.headerIconContainer}>
                    <img
                      style={{ filter: "invert(100%)" }}
                      src="/assets/icons/TracksPageIcons/music-note-02.svg"
                      alt="icon"
                    />
                  </Box>
                  {trackToEdit ? "Edit Track" : "Add Track"}
                </span>
                <IconButton onClick={handleCloseTrackAddModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Formik
                initialValues={newTrack}
                onSubmit={onSubmit}
                validationSchema={TRACK_VALIDATION_SCHEMA}
              >
                {({
                  values,
                  handleChange,
                  isSubmitting,
                  setFieldValue,
                  handleBlur,
                  errors,
                  touched,
                }) => (
                  <Form {...({} as any)}>
                    <Box style={{ color: TEXT_COLOR }} className="form-content">
                      <TrackAddModalMainContainer>
                        <TrackAddModalColumnContainer>
                          <label
                            style={{
                              color:
                                errors.songUpload && touched.songUpload
                                  ? "red"
                                  : TEXT_COLOR,
                            }}
                            htmlFor="audio"
                            className="uploadLabel"
                          >
                            Upload Audio
                            <span className="asterisk">*</span>
                          </label>
                          <Audio
                            handleBlur={handleBlur}
                            setFieldValue={setFieldValue}
                            touched={touched}
                            errors={errors}
                            isSubmitting={isSubmitting}
                            transferClearAudio={saveResetAudioAction}
                            songTitle={""}
                            songUrl={trackUrl}
                            handleSongChanged={handleSongChanged}
                            determineBpm={determineSetBpm}
                            setBpmLoading={setBpmLoading}
                          />

                          <Box className="input" sx={{ marginTop: "20px" }}>
                            <label
                              style={{ color: TEXT_COLOR }}
                              htmlFor="description"
                            >
                              Add a Note{" "}
                              <span className="optional-input">(optional)</span>
                            </label>
                            <textarea
                              style={{
                                ...styles.modalDescription,
                                ...{
                                  color: TEXT_COLOR,
                                  border: `1px solid ${BORDER_COLOR}`,
                                },
                              }}
                              name="description"
                              id="description"
                              placeholder="Enter a note for this version"
                              value={values.description}
                              onFocus={(e) => {
                                e.target.style.boxShadow =
                                  "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                                e.target.style.border = "1px solid gray";
                              }}
                              onChange={(e) => {
                                handleChange(e);
                                setCharCount(e.target.value.length);
                              }}
                              onBlur={(e) => {
                                e.target.style.boxShadow = "none";
                                e.target.style.border = `1px solid gray`;
                                handleBlur(e);
                              }}
                              cols={30}
                              rows={4}
                              disabled={isSubmitting}
                              maxLength={MAX_CHARACTER}
                            ></textarea>
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                fontSize: "12px",
                                color: "gray",
                              }}
                            >
                              {charCount}/{MAX_CHARACTER}
                            </div>
                          </Box>
                          <FormControl
                            sx={{ mb: "32px", mt: "-20px" }}
                            fullWidth
                          >
                            <label>Select Status</label>
                            <Select
                              value={versionState}
                              displayEmpty
                              onChange={handleStatusChange}
                            >
                              {versionStates.map((el) => {
                                return (
                                  <MenuItem
                                    disabled={
                                      el.option === "Specify the file type"
                                    }
                                    key={el.option}
                                    value={el.value}
                                    sx={{ backgroundColor: "inherit" }}
                                  >
                                    {el.option}
                                  </MenuItem>
                                );
                              })}
                            </Select>
                          </FormControl>
                          <Box>
                            <label htmlFor="artwork" className="uploadLabel">
                              Upload Artwork{" "}
                              <span className="optional-input">(optional)</span>
                            </label>
                            <label
                              htmlFor="cover-art-upload"
                              className="image-upload cover-upload"
                              style={{
                                ...trackAddModalStyles.coverArtLabel,
                                ...{
                                  borderStyle: previewUrl ? "none" : "dashed",
                                },
                              }}
                              onBlur={handleBlur}
                              onDragOver={handleDragOver}
                              onDrop={(event: any) => {
                                //prevent the browser from opening the image
                                event.preventDefault();
                                event.stopPropagation();
                                if (
                                  event.dataTransfer.files[0] &&
                                  event.dataTransfer.files[0]?.type?.split(
                                    "/"
                                  )[0] !== "image"
                                ) {
                                  toast.info("Upload an image file");
                                } else {
                                  setFieldValue(
                                    "coverArtUpload",
                                    event.dataTransfer.files[0]
                                  );
                                  const imageFile = event.dataTransfer.files[0];
                                  handleFile(imageFile);
                                }
                              }}
                              onClick={handleBlur}
                            >
                              <input
                                style={{
                                  color: TEXT_COLOR,
                                  backgroundColor: TEXT_COLOR,
                                }}
                                type="file"
                                name="coverArtUpload"
                                id="cover-art-upload"
                                onChange={(event: any) => {
                                  handleFile(event.target.files[0]);
                                  setFieldValue(
                                    "coverArtUpload",
                                    event.currentTarget.files?.[0]
                                  );
                                  event.currentTarget.value = "";
                                }}
                                accept="image/*"
                                onBlur={handleBlur}
                                disabled={isSubmitting}
                              />
                              {!previewUrl && (
                                <>
                                  <Box
                                    sx={
                                      trackAddModalStyles.imageIconMainContainer
                                    }
                                  >
                                    <Box
                                      sx={
                                        trackAddModalStyles.imageIconContainer
                                      }
                                    >
                                      <ImageIcon
                                        sx={{
                                          ...styles.modalImagePlaceholder,
                                          ...{ color: TEXT_COLOR },
                                        }}
                                      />
                                    </Box>
                                    <Typography sx={{ textAlign: "center" }}>
                                      Click to upload or drag and drop <br />
                                      JPG or JPEG, Max size 10 MB
                                      <br />
                                    </Typography>
                                  </Box>
                                  <img
                                    style={{ color: TEXT_COLOR }}
                                    alt=""
                                    className="edit"
                                  />
                                </>
                              )}
                              {previewUrl && (
                                <img
                                  src={previewUrl}
                                  alt="cover"
                                  height={"100%"}
                                  width={"100%"}
                                  color="white"
                                  style={{ borderRadius: "5px" }}
                                />
                              )}
                            </label>
                          </Box>
                        </TrackAddModalColumnContainer>
                        <TrackAddModalColumnContainer>
                          <Box className="input">
                            <label
                              style={{
                                color:
                                  errors.artist && touched.artist
                                    ? "red"
                                    : TEXT_COLOR,
                              }}
                              htmlFor="artist"
                            >
                              Artist
                              <span className="asterisk">*</span>
                            </label>
                            <input
                              style={{
                                backgroundColor: APP_BACKGROUND_COLOR,
                                color: TEXT_COLOR,
                                borderColor:
                                  errors.artist && touched.artist
                                    ? "red"
                                    : BORDER_COLOR,
                              }}
                              type="text"
                              name="artist"
                              id="artist"
                              placeholder="Artist name"
                              value={values.artist}
                              onChange={handleChange}
                              disabled={isSubmitting}
                              onFocus={(e) => {
                                e.target.style.boxShadow =
                                  "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                                e.target.style.border = "1px solid gray";
                              }}
                              onBlur={(e) => {
                                e.target.style.boxShadow = "none";
                                e.target.style.border = `1px solid gray`;
                                handleBlur(e);
                              }}
                            />
                          </Box>
                          <Box className="input">
                            <label
                              style={{
                                color:
                                  errors.title && touched.title
                                    ? "red"
                                    : TEXT_COLOR,
                              }}
                              htmlFor="title"
                            >
                              Title
                              <span className="asterisk">*</span>
                            </label>
                            <input
                              style={{
                                backgroundColor: APP_BACKGROUND_COLOR,
                                color: TEXT_COLOR,
                                borderColor:
                                  errors.title && touched.title
                                    ? "red"
                                    : BORDER_COLOR,
                              }}
                              type="text"
                              name="title"
                              id="title"
                              placeholder="Song title"
                              value={values.title}
                              onChange={handleChange}
                              disabled={isSubmitting}
                              onFocus={(e) => {
                                e.target.style.boxShadow =
                                  "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                                e.target.style.border = "1px solid gray";
                              }}
                              onBlur={(e) => {
                                e.target.style.boxShadow = "none";
                                e.target.style.border = `1px solid gray`;
                                handleBlur(e);
                              }}
                            />
                          </Box>
                          <Box>
                            <Box style={{ marginBottom: 20 }}>
                              <label
                                htmlFor="bio"
                                style={{
                                  ...trackAddModalStyles.genreLabel,
                                  color:
                                    errors.genres && touched.genres
                                      ? "red"
                                      : TEXT_COLOR,
                                }}
                              >
                                {" "}
                                Genre
                                <span className="asterisk">*</span>
                              </label>
                              <Stack spacing={3} sx={{}}>
                                <Autocomplete
                                  disabled={isSubmitting}
                                  autoComplete
                                  multiple
                                  value={genres || null}
                                  sx={
                                    errors.genres && touched.genres
                                      ? autoCompleteErrorStyle
                                      : autoCompleteStlye
                                  }
                                  options={GenresArray}
                                  onChange={(
                                    event: React.SyntheticEvent<Element, Event>,
                                    value: string[] | null,
                                    _reason: AutocompleteChangeReason
                                  ) => {
                                    if (value != null) {
                                      setGenres(value);
                                      setFieldValue("genres", value);
                                    }
                                  }}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      label={
                                        genres.length === 0 || null
                                          ? "Song genre"
                                          : ""
                                      }
                                      InputLabelProps={{
                                        shrink: false,
                                      }}
                                      classes={{
                                        root: classes.customTextField,
                                      }}
                                    />
                                  )}
                                  renderOption={(props, option) => (
                                    <li
                                      {...props}
                                      style={{ fontFamily: FONT_FAMILY }}
                                    >
                                      {option}
                                    </li>
                                  )}
                                />
                              </Stack>
                            </Box>
                          </Box>
                          {
                            <Box className="input">
                              <label
                                htmlFor="bpm"
                                style={{
                                  ...styles.modalBpmLabel,
                                  ...{ color: TEXT_COLOR },
                                }}
                              >
                                BPM{" "}
                                <span className="optional-input">
                                  (optional)
                                </span>
                                <Box
                                  style={{ display: "inline" }}
                                  onMouseOver={() => setShowBpmTooltip(true)}
                                  onMouseLeave={() => setShowBpmTooltip(false)}
                                >
                                  <LightTooltip
                                    title="Beats per minute (will be detected automatically)"
                                    placement="top"
                                    open={showBpmTooltip}
                                    onClick={handleshowBpmTooltip}
                                  >
                                    <IconButton disableRipple>
                                      <HelpOutlineIcon
                                        color="info"
                                        style={{ height: 16, width: 16 }}
                                      />
                                    </IconButton>
                                  </LightTooltip>
                                </Box>
                              </label>
                              {!bpmLoading && (
                                <Box style={trackAddModalStyles.bpmContainer}>
                                  <input
                                    style={{
                                      backgroundColor: APP_BACKGROUND_COLOR,
                                      color: TEXT_COLOR,
                                      borderColor: BORDER_COLOR,
                                      ...(!songChanged
                                        ? {
                                            opacity: 0.6,
                                            cursor: "not-allowed",
                                          }
                                        : {}),
                                    }}
                                    type="number"
                                    name="bpm"
                                    id="bpm"
                                    min="0"
                                    max="200"
                                    step="1"
                                    placeholder="BPM range 0-200"
                                    value={values.bpm}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    disabled={isSubmitting || !songChanged}
                                  />
                                </Box>
                              )}
                              {bpmLoading && (
                                <Box
                                  sx={trackAddModalStyles.bpmLoadingContainer}
                                >
                                  <LinearProgress color="inherit" />
                                </Box>
                              )}
                            </Box>
                          }
                          <Box className="input">
                            <label
                              style={{ color: TEXT_COLOR }}
                              htmlFor="album"
                            >
                              Album{" "}
                              <span className="optional-input">(optional)</span>
                            </label>
                            <input
                              style={trackAddModalStyles.albumInput}
                              type="text"
                              name="album"
                              id="album"
                              placeholder="Album name"
                              value={values.album}
                              onChange={handleChange}
                              disabled={isSubmitting}
                              onFocus={(e) => {
                                e.target.style.boxShadow =
                                  "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                                e.target.style.border = "1px solid gray";
                              }}
                              onBlur={(e) => {
                                e.target.style.boxShadow = "none";
                                e.target.style.border = `1px solid gray`;
                                handleBlur(e);
                              }}
                            />
                          </Box>
                          <KeyComponent
                            songKey={key}
                            scale={scale}
                            showKeyTooltip={showKeyTooltip}
                            handleKey={handleKey}
                            handleScale={handleScale}
                            handleshowKeyTooltip={handleshowKeyTooltip}
                            setShowKeyTooltip={setShowKeyTooltip}
                          />
                        </TrackAddModalColumnContainer>
                      </TrackAddModalMainContainer>

                      <Box>
                        <span>Add Collaborators </span>
                        <span className="optional-input">(optional)</span>
                        <Box
                          style={{ display: "inline" }}
                          onMouseOver={() => setShowCollabTooltip(true)}
                          onMouseLeave={() => setShowCollabTooltip(false)}
                        >
                          <LightTooltip
                            title="You can add artists, composers, and more collaborators"
                            placement="top"
                            open={showCollabTooltip}
                            onClick={handleShowCollabTooltip}
                          >
                            <IconButton disableRipple>
                              <HelpOutlineIcon
                                color="info"
                                style={{ height: 16, width: 16 }}
                              />
                            </IconButton>
                          </LightTooltip>
                        </Box>
                      </Box>
                      <hr />
                      <TrackAddModalMainContainer>
                        <TrackAddModalColumnContainer>
                          <Box
                            sx={
                              trackAddModalStyles.userNameSelectFieldContainer
                            }
                          >
                            <Box sx={{ width: "80%" }}>
                              <label
                                htmlFor="newCollaboratorUser"
                                style={styles.modalCreatorUsername}
                              >
                                {"Creator's Username"}
                              </label>
                              <UsernameSelectField
                                freeSolo
                                forcePopupIcon={false}
                                isOptionEqualToValue={(option, value) =>
                                  option === value
                                }
                                inputValue={collabVal}
                                onInputChange={(
                                  event: React.SyntheticEvent<Element, Event>,
                                  value: string
                                ) => {
                                  setCollabVal(value);
                                }}
                                options={usersList
                                  .map((item) => item.getUsername())
                                  .sort()}
                                renderInput={(params) => (
                                  <TextField
                                    style={{
                                      backgroundColor: APP_BACKGROUND_COLOR,
                                      color: TEXT_COLOR,
                                    }}
                                    {...params}
                                    label={
                                      collabVal === ""
                                        ? "Select creators username"
                                        : ""
                                    }
                                    InputLabelProps={{
                                      shrink: false,
                                    }}
                                    classes={{ root: classes.customTextField }}
                                  />
                                )}
                                renderOption={(props, option: any) => (
                                  <li
                                    {...props}
                                    style={{ fontFamily: FONT_FAMILY }}
                                  >
                                    {option}
                                  </li>
                                )}
                              />
                            </Box>
                            <Button
                              disabled={collabVal === ""}
                              sx={trackAddModalStyles.addUserNameButton}
                              size="small"
                              variant="contained"
                              onClick={() => {
                                if (!isSubmitting) {
                                  addCollaborator(collabVal);
                                }
                              }}
                            >
                              Add
                            </Button>
                          </Box>
                          <Box
                            className="collaborators"
                            style={{ margin: "20px 0 40px" }}
                          >
                            <Box className="collaborators-target">
                              {collaborators &&
                                collaborators.length > 0 &&
                                collaborators.map((collaborator, index) => (
                                  <Box
                                    sx={{ border: `1px solid ${BORDER_COLOR}` }}
                                    className="collaborator"
                                    key={index}
                                  >
                                    <p
                                      style={{
                                        fontFamily: FONT_FAMILY,
                                        flexGrow: 1,
                                      }}
                                    >
                                      {collaborator.getUsername()}
                                    </p>
                                    {!isSubmitting &&
                                      collaborator.getUserId() !== userId && (
                                        <IconButton
                                          onClick={() =>
                                            removeCollaborator(collaborator)
                                          }
                                        >
                                          <DeleteForeverIcon />
                                        </IconButton>
                                      )}

                                    {collaborator.getUserId() === userId && (
                                      <Chip label="You" color="info" />
                                    )}
                                  </Box>
                                ))}
                            </Box>
                          </Box>
                        </TrackAddModalColumnContainer>
                        <TrackAddModalColumnContainer>
                          {!isEnterprise && (
                            <Box sx={trackAddModalStyles.inviteEmailContainer}>
                              <Box sx={{ width: "80%" }}>
                                <label
                                  htmlFor="emailInvite"
                                  style={styles.modalCreatorUsername}
                                >
                                  {"Invite Collaborator"}
                                </label>
                                <EmailInviteTextField
                                  hiddenLabel
                                  variant="outlined"
                                  classes={{ root: classes.customTextField }}
                                  placeholder="Send an invite email to a collaborator"
                                  value={emailInvite}
                                  onChange={(
                                    event: React.ChangeEvent<
                                      HTMLTextAreaElement | HTMLInputElement
                                    >
                                  ) => setEmailInvite(event.target.value)}
                                />
                              </Box>
                              <Button
                                disabled={emailInvite === ""}
                                sx={trackAddModalStyles.inviteEmailButton}
                                size="small"
                                variant="contained"
                                onClick={handleCollabInvites}
                              >
                                Add
                              </Button>
                            </Box>
                          )}
                          <Box style={{ marginBottom: 10, width: "100%" }}>
                            <Box>
                              {emailInviteList &&
                                emailInviteList.length > 0 &&
                                emailInviteList.map((email, index) => (
                                  <Box
                                    className="collaborator"
                                    style={{ width: "100%" }}
                                    sx={{ border: `1px solid ${BORDER_COLOR}` }}
                                    key={index}
                                  >
                                    <p style={trackAddModalStyles.email}>
                                      {email}
                                    </p>

                                    <IconButton
                                      onClick={() => handleRemoveEmail(email)}
                                    >
                                      <DeleteForeverIcon />
                                    </IconButton>
                                  </Box>
                                ))}
                            </Box>
                          </Box>
                        </TrackAddModalColumnContainer>
                      </TrackAddModalMainContainer>
                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                          onClick={handleCloseTrackAddModal}
                          sx={{
                            ...styles.skipButton,
                            ...{ marginRight: "25px" },
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          disabled={isSubmitting}
                          fullWidth
                          type="submit"
                          sx={styles.modalSubmitButton}
                          size="small"
                          variant="contained"
                        >
                          {isSubmitting ? (
                            <>
                              <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                color="black"
                              />{" "}
                              <span style={trackAddModalStyles.uploadingSpan}>
                                {`Uploading ${currentUpload}`}
                              </span>
                            </>
                          ) : (
                            <Typography
                              variant="h1"
                              sx={styles.modalSubmitButtonText}
                            >
                              {trackToEdit ? "Update Track" : "Add Track"}
                            </Typography>
                          )}
                        </Button>
                      </Box>
                      {isSubmitting && (
                        <CustomLinearProgress value={progress} />
                      )}
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </TrackAddModalFormContainer>
        )}
        {trackToEdit && (
          <TrackEditModalFormContainer
            sx={{ width: isSmallScreen ? "95%" : "400px" }}
          >
            <Box>
              <Box style={styles.modalHeaderContainer}>
                <span style={styles.modalHeader}>
                  <Box sx={trackAddModalStyles.headerIconContainer}>
                    <img
                      style={{ filter: "invert(100%)" }}
                      src="/assets/icons/TracksPageIcons/music-note-02.svg"
                      alt="icon"
                    />
                  </Box>
                  {trackToEdit ? "Edit Track" : "Add Track"}
                </span>
                <IconButton onClick={handleCloseTrackAddModal}>
                  <CloseIcon />
                </IconButton>
              </Box>
              <Formik
                initialValues={newTrack}
                onSubmit={onSubmit}
                validationSchema={TRACK_EDIT_VALIDATION_SCHEMA}
              >
                {({
                  values,
                  handleChange,
                  isSubmitting,
                  setFieldValue,
                  handleBlur,
                  errors,
                  touched,
                }) => (
                  <Form {...({} as any)}>
                    <Box style={{ color: TEXT_COLOR }} className="form-content">
                      <TrackEditModalColumnContainer>
                        <Box>
                          <label htmlFor="artwork" className="uploadLabel">
                            Upload Artwork{" "}
                            <span className="optional-input">(optional)</span>
                          </label>
                          <label
                            htmlFor="cover-art-upload"
                            className="image-upload cover-upload"
                            style={{
                              ...trackAddModalStyles.coverArtLabel,
                              ...{
                                borderStyle: previewUrl ? "none" : "dashed",
                              },
                            }}
                            onBlur={handleBlur}
                            onDragOver={handleDragOver}
                            onDrop={(event: any) => {
                              //prevent the browser from opening the image
                              event.preventDefault();
                              event.stopPropagation();
                              if (
                                event.dataTransfer.files[0] &&
                                event.dataTransfer.files[0]?.type?.split(
                                  "/"
                                )[0] !== "image"
                              ) {
                                toast.info("Upload an image file");
                              } else {
                                setFieldValue(
                                  "coverArtUpload",
                                  event.dataTransfer.files[0]
                                );
                                const imageFile = event.dataTransfer.files[0];
                                handleFile(imageFile);
                              }
                            }}
                            onClick={handleBlur}
                          >
                            <input
                              style={{
                                color: TEXT_COLOR,
                                backgroundColor: TEXT_COLOR,
                              }}
                              type="file"
                              name="coverArtUpload"
                              id="cover-art-upload"
                              onChange={(event: any) => {
                                handleFile(event.target.files[0]);
                                setFieldValue(
                                  "coverArtUpload",
                                  event.currentTarget.files?.[0]
                                );
                                event.currentTarget.value = "";
                              }}
                              accept="image/*"
                              onBlur={handleBlur}
                              disabled={isSubmitting}
                            />
                            {!previewUrl && (
                              <>
                                <Box
                                  sx={
                                    trackAddModalStyles.imageIconMainContainer
                                  }
                                >
                                  <Box
                                    sx={trackAddModalStyles.imageIconContainer}
                                  >
                                    <ImageIcon
                                      sx={{
                                        ...styles.modalImagePlaceholder,
                                        ...{ color: TEXT_COLOR },
                                      }}
                                    />
                                  </Box>
                                  <Typography sx={{ textAlign: "center" }}>
                                    Click to upload or drag and drop <br />
                                    JPG or JPEG, Max size 10 MB
                                    <br />
                                  </Typography>
                                </Box>
                                <img
                                  style={{ color: TEXT_COLOR }}
                                  alt=""
                                  className="edit"
                                />
                              </>
                            )}
                            {previewUrl && (
                              <img
                                src={previewUrl}
                                alt="cover"
                                height={"100%"}
                                width={"100%"}
                                color="white"
                                style={{ borderRadius: "5px" }}
                              />
                            )}
                          </label>
                        </Box>

                        <Box className="input">
                          <label
                            style={{
                              marginTop: "20px",
                              color:
                                errors.artist && touched.artist
                                  ? "red"
                                  : TEXT_COLOR,
                            }}
                            htmlFor="artist"
                          >
                            Artist
                            <span className="asterisk">*</span>
                          </label>
                          <input
                            style={{
                              backgroundColor: APP_BACKGROUND_COLOR,
                              color: TEXT_COLOR,
                              borderColor:
                                errors.artist && touched.artist
                                  ? "red"
                                  : BORDER_COLOR,
                            }}
                            type="text"
                            name="artist"
                            id="artist"
                            placeholder="Artist name"
                            value={values.artist}
                            onChange={handleChange}
                            disabled={isSubmitting}
                            onFocus={(e) => {
                              e.target.style.boxShadow =
                                "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                              e.target.style.border = "1px solid gray";
                            }}
                            onBlur={(e) => {
                              e.target.style.boxShadow = "none";
                              e.target.style.border = `1px solid gray`;
                              handleBlur(e);
                            }}
                          />
                        </Box>
                        <Box className="input">
                          <label
                            style={{
                              color:
                                errors.title && touched.title
                                  ? "red"
                                  : TEXT_COLOR,
                            }}
                            htmlFor="title"
                          >
                            Title
                            <span className="asterisk">*</span>
                          </label>
                          <input
                            style={{
                              backgroundColor: APP_BACKGROUND_COLOR,
                              color: TEXT_COLOR,
                              borderColor:
                                errors.title && touched.title
                                  ? "red"
                                  : BORDER_COLOR,
                            }}
                            type="text"
                            name="title"
                            id="title"
                            placeholder="Song title"
                            value={values.title}
                            onChange={handleChange}
                            disabled={isSubmitting}
                            onFocus={(e) => {
                              e.target.style.boxShadow =
                                "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                              e.target.style.border = "1px solid gray";
                            }}
                            onBlur={(e) => {
                              e.target.style.boxShadow = "none";
                              e.target.style.border = `1px solid gray`;
                              handleBlur(e);
                            }}
                          />
                        </Box>
                        <Box>
                          <Box style={{ marginBottom: 20 }}>
                            <label
                              htmlFor="bio"
                              style={{
                                ...trackAddModalStyles.genreLabel,
                                ...{
                                  color:
                                    errors.genres && touched.genres
                                      ? "red"
                                      : TEXT_COLOR,
                                },
                              }}
                            >
                              {" "}
                              Genre
                              <span className="asterisk">*</span>
                            </label>
                            <Stack spacing={3} sx={{}}>
                              <Autocomplete
                                multiple
                                disabled={isSubmitting}
                                autoComplete
                                value={genres || []}
                                sx={
                                  errors.genres && touched.genres
                                    ? autoCompleteErrorStyle
                                    : autoCompleteStlye
                                }
                                options={GenresArray}
                                onChange={(
                                  event: React.SyntheticEvent<Element, Event>,
                                  value: string[] | null,
                                  _reason: AutocompleteChangeReason
                                ) => {
                                  if (value != null) {
                                    setGenres(value);
                                    setFieldValue("genres", value);
                                  } else {
                                    setGenres([]);
                                    setFieldValue("genres", "");
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      genres.length === 0 || null
                                        ? "Song genre"
                                        : ""
                                    }
                                    InputLabelProps={{
                                      shrink: false,
                                    }}
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                  />
                                )}
                                renderOption={(props, option) => (
                                  <li
                                    {...props}
                                    style={{ fontFamily: FONT_FAMILY }}
                                  >
                                    {option}
                                  </li>
                                )}
                              />
                            </Stack>
                          </Box>
                          <Box style={{ marginBottom: 20 }}>
                            <label
                              htmlFor="bio"
                              style={{
                                ...trackAddModalStyles.genreLabel,
                                ...{
                                  color: TEXT_COLOR,
                                },
                              }}
                            >
                              {" "}
                              Mood
                            </label>
                            <Stack spacing={3} sx={{}}>
                              <Autocomplete
                                multiple
                                disabled={isSubmitting}
                                autoComplete
                                value={moods || []}
                                sx={autoCompleteStlye}
                                options={MoodsArray}
                                onChange={(
                                  event: React.SyntheticEvent<Element, Event>,
                                  value: string[] | null,
                                  _reason: AutocompleteChangeReason
                                ) => {
                                  if (value != null) {
                                    setMoods(value);
                                    setFieldValue("moods", value);
                                  } else {
                                    setMoods([]);
                                    setFieldValue("moods", "");
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label={
                                      moods.length === 0 || null
                                        ? "Song mood"
                                        : ""
                                    }
                                    InputLabelProps={{
                                      shrink: false,
                                    }}
                                    classes={{
                                      root: classes.customTextField,
                                    }}
                                  />
                                )}
                                renderOption={(props, option) => (
                                  <li
                                    {...props}
                                    style={{ fontFamily: FONT_FAMILY }}
                                  >
                                    {option}
                                  </li>
                                )}
                              />
                            </Stack>
                          </Box>
                        </Box>
                        <Box className="input">
                          <label style={{ color: TEXT_COLOR }} htmlFor="album">
                            Album{" "}
                            <span className="optional-input">(optional)</span>
                          </label>
                          <input
                            style={trackAddModalStyles.albumInput}
                            type="text"
                            name="album"
                            id="album"
                            placeholder="Album name"
                            value={values.album}
                            onChange={handleChange}
                            disabled={isSubmitting}
                            onFocus={(e) => {
                              e.target.style.boxShadow =
                                "0px 1px 2px 0px rgba(16, 24, 40, 0.05), 0px 0px 0px 4px rgba(158, 119, 237, 0.24)";
                              e.target.style.border = "1px solid gray";
                            }}
                            onBlur={(e) => {
                              e.target.style.boxShadow = "none";
                              e.target.style.border = `1px solid gray`;
                              handleBlur(e);
                            }}
                          />
                        </Box>
                      </TrackEditModalColumnContainer>

                      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                        <Button
                          disabled={isSubmitting}
                          fullWidth
                          type="submit"
                          sx={styles.modalSubmitButton}
                          size="small"
                          variant="contained"
                        >
                          {isSubmitting ? (
                            <>
                              <Spinner
                                as="span"
                                animation="grow"
                                size="sm"
                                role="status"
                                aria-hidden="true"
                                color="black"
                              />{" "}
                              <span style={trackAddModalStyles.uploadingSpan}>
                                {`Uploading ${currentUpload}`}
                              </span>
                            </>
                          ) : (
                            <Typography
                              variant="h1"
                              sx={styles.modalSubmitButtonText}
                            >
                              {trackToEdit ? "Update Track" : "Add Track"}
                            </Typography>
                          )}
                        </Button>
                        <Button
                          onClick={handleCloseTrackAddModal}
                          sx={{
                            ...styles.skipButton,
                            ...{ marginRight: "25px" },
                          }}
                        >
                          Cancel
                        </Button>
                      </Box>
                      {isSubmitting && (
                        <CustomLinearProgress value={progress} />
                      )}
                    </Box>
                  </Form>
                )}
              </Formik>
            </Box>
          </TrackEditModalFormContainer>
        )}
      </>
    </ContainerModal>
  );
};

export default TrackAddModal;
